'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Bar = function () {
    function Bar(template) {
        _classCallCheck(this, Bar);
        this.elements = {};
        this.elements.volume = template.volumeBar;
        this.elements.played = template.playedBar;
        this.elements.loaded = template.loadedBar;
        this.elements.danmaku = template.danmakuOpacityBar;
    }
    _createClass(Bar, [
        {
            key: 'set',
            value: function set(type, percentage, direction) {
                percentage = Math.max(percentage, 0);
                percentage = Math.min(percentage, 1);
                this.elements[type].style[direction] = percentage * 100 + '%';
            }
        },
        {
            key: 'get',
            value: function get(type) {
                return parseFloat(this.elements[type].style.width) / 100;
            }
        }
    ]);
    return Bar;
}();
exports.default = Bar;


//////////////////
// WEBPACK FOOTER
// ./src/js/bar.js
// module id = 14
// module chunks = 0